import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, Bell, Target, Tag, UserCircle, X } from 'lucide-react';
const menuItems = [{
  icon: LayoutDashboard,
  label: 'Dashboard',
  path: '/'
}, {
  icon: Users,
  label: 'Usuários',
  path: '/users'
}, {
  icon: Target,
  label: 'Sonhos',
  path: '/dreams'
}, {
  icon: Bell,
  label: 'Notificações Push',
  path: '/notifications'
}, {
  icon: Tag,
  label: 'Categorias Padrão',
  path: '/categories'
}, {
  icon: UserCircle,
  label: 'Perfil',
  path: '/profile'
}];
interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}
export function Sidebar({
  isOpen,
  onClose
}: SidebarProps) {
  const location = useLocation();
  return <div className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 flex flex-col transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`} data-id="element-124">
      <div className="h-16 flex items-center justify-between px-6 border-b border-gray-200" style={{
      backgroundColor: '#9fcec7'
    }} data-id="element-125">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oEPBx5QXAMT9yTWwGf88PP/logo-B_Q9iFuH.png" alt="iDreamy" className="h-10" data-id="element-126" />
        <button onClick={onClose} className="lg:hidden p-1 text-gray-700 hover:text-gray-900" data-id="element-127">
          <X className="w-6 h-6" data-id="element-128" />
        </button>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1" data-id="element-129">
        {menuItems.map(item => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return <Link key={item.path} to={item.path} onClick={onClose} className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${isActive ? 'bg-gradient-to-r from-[#D4EDED] to-[#E8F4F4] text-[#2C4A6B]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-130">
              <Icon className="w-5 h-5" data-id="element-131" />
              <span className="font-medium" data-id="element-132">{item.label}</span>
            </Link>;
      })}
      </nav>
    </div>;
}